export * as entities from './entities'
export * from './innovation-assets-project'
